export default __webpack_public_path__ + "aead150f10feef335d31611c7d8b084d.svg";